import React from 'react';
import { grey } from '@mui/material/colors';

export const LIGHT = 'light';
export const DARK = 'dark';

export const ColorModeContext = React.createContext({
    toggleColorMode: () => {},
});

export const isDarkMode = theme => theme.palette.mode === DARK;

export const getModeVisibleColor = theme => {
    return isDarkMode(theme) ? '#E0E0E0' : '#000';
};

export const getPanelBackground = theme => {
    return isDarkMode(theme) ? '#202a40' : grey[50];
};

export const getContentBackground = theme => {
    return isDarkMode(theme) ? 'transparent' : grey[300];
};

export const gridCellCssClass = theme => {
    return { class: isDarkMode(theme) ? 'darkMode' : 'lightMode' };
};

export const getThemeClass = theme => {
    return isDarkMode(theme) ? 'darkMode' : 'lightMode';
};
